import { Avatar, Box, Button, Flex, InputMask, MaskEnum, Message } from 'ui'
import styled from 'styled-components'
import {
  ShiftSupervisor,
  StaffForm,
  SupervisorRequestType,
} from '../../schemas'
import { ExternalSupervisor } from './ExternalSupervisor'
import { Controller, FieldErrors, UseFormRegister } from 'react-hook-form'

type SupervisorCardProps = {
  supervisor: Pick<ShiftSupervisor, 'id' | 'name' | 'requestType'>
  index: number
  errors?: FieldErrors<ShiftSupervisor>
  register: UseFormRegister<StaffForm>
  sendInvite: boolean
  onRemove: () => void
}

const CardContainer = styled(Flex).attrs({
  width: 1,
  p: 3,
  my: 3,
})`
  ${({ theme: { colors, radii } }) => `
    background-color: ${colors.neutrals[50]};
    border-radius: ${radii.standard};
  `}
`

export function SupervisorCard({
  supervisor,
  index,
  errors,
  register,
  sendInvite,
  onRemove,
}: SupervisorCardProps) {
  if (supervisor.requestType === SupervisorRequestType.FreeForm) {
    return (
      <CardContainer>
        <ExternalSupervisor
          index={index}
          errors={errors}
          register={register}
          sendInvite={sendInvite}
          onRemove={onRemove}
        />
      </CardContainer>
    )
  }

  return (
    <CardContainer
      flexDirection={'row'}
      alignItems={['flex-start', 'center']}
      flexWrap={'wrap'}
    >
      <Avatar
        size={'medium'}
        user={{
          userId: supervisor.id.toString(),
          name: supervisor.name,
        }}
      />
      <Flex
        flex={1}
        flexDirection={['column', 'row']}
        alignItems={['flex-start', 'center']}
      >
        <Box ml={2} flex={1} style={{ textTransform: 'capitalize' }}>
          {supervisor.name}
        </Box>
        <Box ml={2} flex={1}>
          <Controller
            name={`supervisors.${index}.phoneNumber` as const}
            render={({ field }) => (
              <InputMask
                variant={'small'}
                mask={MaskEnum.PhoneNumberAlternate}
                {...field}
              />
            )}
          />
        </Box>
        <Button
          kind={'medium'}
          variant={'text'}
          onClick={onRemove}
          mt={[2, 0]}
          ml={[2, 0]}
        >
          Remove
        </Button>
      </Flex>
      {errors?.phoneNumber ? (
        <Message width={1} mt={3} variant={'error'}>
          {errors.phoneNumber.message?.toString()}
        </Message>
      ) : null}
    </CardContainer>
  )
}
